import React from 'react';
export var BanorteLogo = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "data-testid": "banorte-bank-logo",
    height: "24",
    width: "84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("title", {
    id: "banorte-logo-title"
  }, title), React.createElement("defs", null, React.createElement("path", {
    d: "M4 0h316a4 4 0 014 4v92a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    id: "banorte-a"
  }), React.createElement("mask", {
    fill: "#fff",
    id: "banorte-b"
  }, React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#banorte-a"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-33-394h360v1850H-33z",
    fill: "#fff"
  }), React.createElement("g", {
    transform: "translate(-15 -70)"
  }, React.createElement("use", {
    fill: "#f5f7fa",
    xlinkHref: "#banorte-a"
  }), React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#banorte-b)"
  }, React.createElement("path", {
    d: "M96 70H18c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h78c1.7 0 3-1.3 3-3V73c0-1.7-1.4-3-3-3z",
    fill: "#000",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M98 73v18c0 1.1-.9 2-2 2H18c-1.1 0-2-.9-2-2V73c0-1.1.9-2 2-2h78c1.1 0 2 .9 2 2z",
    fill: "#fff"
  }), React.createElement("g", {
    fill: "#ec1c2d"
  }, React.createElement("path", {
    d: "M43.6 82.314h.08c.453 0 .812-.36.812-.812v-.708c0-.417-.046-.614-.208-.835-.232-.29-.638-.417-1.033-.417h-4.918v5.718h4.489c.51 0 1.114-.07 1.427-.406.29-.313.301-.556.301-1.322v-.255a.95.95 0 00-.95-.963m-3.84-1.728h2.97c.15 0 .463.058.463.301v.627c0 .197-.29.278-.406.278H39.76zm3.456 3.224c0 .174-.139.314-.313.314H39.76v-1.276h3.12c.186 0 .336.15.336.336zM51.499 85.272h1.624l-3.283-5.719h-1.334l-3.225 5.719h1.45l.673-1.241h3.434zm-3.492-2.355l1.125-2.065 1.102 2.065zM59.387 79.553v2.877l.035.882-4.466-3.759h-.974v5.719h1.298v-2.877l-.034-.881 4.442 3.758h.998v-5.719zM68.006 85.272h-4.42c-.394 0-.824-.093-1.056-.371-.197-.22-.232-.603-.232-.917v-3.143c0-.36.047-.743.279-.975s.65-.313 1.009-.313h4.42c.394 0 .823.081 1.055.36.186.22.232.615.232.928v3.143c0 .325-.035.696-.232.917-.232.278-.661.371-1.055.371m-4.292-4.57v3.422h4.164v-3.422zM75.812 85.272h2.007l-2.563-2.111h.788c.604 0 1.102-.487 1.102-1.102v-1.415c0-.604-.487-1.102-1.102-1.102H70.952V85.272h1.415v-2.111h1.125zm-3.445-4.628h3.109c.15 0 .267.116.267.266v.894c0 .15-.116.266-.267.266h-3.109zM84.721 79.553H78.19v1.137h2.564v4.582h1.415V80.69h2.552zM87.285 84.112v-1.276h2.68v-1.102h-2.68v-1.079H91.6v-1.102h-5.73v5.719h5.788v-1.16zM29.482 77.581c-3.306 0-5.986.87-5.986 1.949 0 .905 1.868 1.659 4.408 1.88l1.044-3.214.186 3.271h.36c3.306 0 5.985-.87 5.985-1.949-.011-1.055-2.691-1.937-5.997-1.937M27.87 81.525c-3.225.035-5.812 1.056-5.812 2.32 0 1.067 1.833 1.96 4.338 2.239zM29.122 81.56l.256 4.547c2.656-.232 4.628-1.16 4.628-2.262.012-1.137-2.1-2.088-4.884-2.285"
  }))))));
};
BanorteLogo.defaultProps = {
  title: 'Banorte'
};